import { IPublicTypeCompositeObject, IPublicTypeNodeData } from './';

export type IPublicTypePropsMap = IPublicTypeCompositeObject<IPublicTypeNodeData | IPublicTypeNodeData[]>;
